export const name = "TIMESTAMP_SECONDS";
export const summary = `Converts the number of seconds since 1970-01-01 00:00:00 UTC to a \`TIMESTAMP\`.`;
export const reference = `
## TIMESTAMP_SECONDS

Converts the number of seconds since 1970-01-01 00:00:00 UTC to a \`TIMESTAMP\`.

\`\`\`
TIMESTAMP_SECONDS(int64_expression)
\`\`\`

### Description

Interprets \`int64_expression\` as the number of seconds since 1970-01-01 00:00:00 UTC and returns a timestamp.


### Return Data Type

\`TIMESTAMP\`


### Example



\`\`\`
SELECT TIMESTAMP_SECONDS(1230219000) AS timestamp_value;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------*
 | timestamp_value |
 +-------------------------+
 | 2008-12-25 15:30:00 UTC |
 *-------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
